export function AppTitle() {
  return (
    <div
      style={{
        display: "inline-block",
        fontWeight: "bold",
        fontSize: "24px",
        textShadow: "#FFFFFF 0.2px 0.2px 1px",
        // WebkitTextStroke: "0.2px #ffffff",
      }}
    >
      <span style={{ color: "#FF0018" }}>W</span>
      <span style={{ color: "#FFA52C" }}>e</span>
      <span style={{ color: "#FFFF41" }}>e</span>
      <span style={{ color: "#008018" }}>p</span>
      <span style={{ color: "#0000F9" }}>y</span>
      <span style={{ color: "#86007D" }}>E</span>
      <span style={{ color: "#FF0018" }}>y</span>
      <span style={{ color: "#FFA52C" }}>e</span>
      <span style={{ color: "#FFFF41" }}>s</span>
    </div>
  );
}
